/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
import {
  ALL_TSHIRT_SIZES,
  COUNTRIES,
  GENDERS,
  TSHIRT_SIZES,
} from '../../../constants/models'
import FormDatePicker from '../elements/FormDatePicker'
import FormSelectInput from '../elements/FormSelectInput'
import FormTextInput from '../elements/FormTextInput'
import emergencyContact from '../emergencyContact/content'
import { NO_PASTE_PROPS } from '../utils/pasteProps'
import shirtFieldInputs from '../utils/shirtFieldInputs'

const _shirtFields = ({ key, fullShirtDetails, hasBibName, hasJersey, formDisabled }: any) =>
  shirtFieldInputs({ key, fullShirtDetails, formDisabled, sizeMd: hasBibName || hasJersey ? 4 : 6 })

const IndividualUserFormContent = ({
  isVirtual,
  formDisabled,
  showRepeater,
  hasBibName,
  hasJersey,
  fullShirtDetails,
}) => [
  {
    id: 'category-form-details',
    name: 'Event',
    inputs: [
      {
        ...(hasJersey && {
          id: 'jerseySize',
          size: { sm: 12, md: 4 },
          field: (
            <FormSelectInput
              name="jerseySize"
              label={`${
                fullShirtDetails.shirtDetails?.JERSEY?.LABEL || 'Cycling jersey'
              } size`}
              autoComplete="new-jerseySize"
              placeholder={`Select ${
                fullShirtDetails.shirtDetails?.JERSEY?.LABEL || 'Cycling jersey'
              } size`}
              disabled={formDisabled}
              options={
                `JERSEY` in fullShirtDetails.shirtDetails &&
                'SIZE_OPTIONS' in fullShirtDetails.shirtDetails.JERSEY
                  ? fullShirtDetails.shirtDetails.JERSEY.SIZE_OPTIONS.map(
                      (value: string) => ({
                        value,
                        text: ALL_TSHIRT_SIZES[value],
                      }),
                    )
                  : Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
                      value: key,
                      text: value,
                    }))
              }
              required
            />
          ),
        }),
      },
      ..._shirtFields({
        key: 1,
        fullShirtDetails,
        hasBibName,
        hasJersey,
        formDisabled,
      }),
      ..._shirtFields({
        key: 2,
        fullShirtDetails,
        hasBibName,
        hasJersey,
        formDisabled,
      }),
      {
        id: 'teamName',
        size: { sm: 12, md: hasBibName || hasJersey ? 4 : 6 },
        field: (
          <FormTextInput
            name="teamName"
            label="Team Name"
            autoComplete="new-teamName"
            disabled={formDisabled}
          />
        ),
      },
      {
        ...(hasBibName && {
          id: 'bibName',
          size: { sm: 12, md: 4 },
          field: (
            <FormTextInput
              name="bibName"
              label="Name in bib"
              autoComplete="new-bibName"
              disabled={formDisabled}
            />
          ),
        }),
      },
    ],
  },
  {
    id: 'user-form-details',
    name: 'Participant Information',
    inputs: [
      {
        id: 'firstName',
        size: { sm: 12, md: 6 },
        field: (
          <FormTextInput
            name="firstName"
            label="First Name"
            required
            autoComplete="new-firstName"
            disabled={showRepeater || formDisabled}
          />
        ),
      },
      {
        id: 'lastName',
        size: { sm: 12, md: 6 },
        field: (
          <FormTextInput
            name="lastName"
            label="Last Name"
            required
            autoComplete="new-lastName"
            disabled={showRepeater || formDisabled}
          />
        ),
      },
      {
        id: 'email',
        size: { sm: 12, md: 6 },
        field: (
          <FormTextInput
            name="email"
            label="Email Address"
            required
            autoComplete="new-email"
            disabled={formDisabled}
          />
        ),
      },
      {
        id: 'confirmEmail',
        size: { sm: 12, md: 6 },
        field: (
          <FormTextInput
            name="confirmEmail"
            label="Confirm Email Address"
            required
            autoComplete="new-confirmEmail"
            disabled={formDisabled}
            {...NO_PASTE_PROPS}
          />
        ),
      },
      {
        id: 'birthdate',
        size: { sm: 12, md: 4 },
        field: (
          <FormDatePicker
            name="birthdate"
            label="Birthdate"
            required
            autoComplete="new-birthdate"
            placeholder="YYYY-MM-DD"
            disabled={formDisabled}
          />
        ),
      },
      {
        id: 'nationality',
        size: { sm: 12, md: 4 },
        field: (
          <FormSelectInput
            name="nationality"
            label="Nationality"
            autoComplete="new-nationality"
            placeholder="Select Nationality"
            disabled={formDisabled}
            options={Object.entries(COUNTRIES).map(([key, value]) => ({
              value: key,
              text: value,
            }))}
            required
          />
        ),
      },
      {
        id: 'gender',
        size: { sm: 12, md: 4 },
        field: (
          <FormSelectInput
            name="gender"
            label="Gender"
            autoComplete="new-gender"
            placeholder="Select Gender"
            disabled={formDisabled}
            options={Object.entries(GENDERS).map(([key, value]) => ({
              value: key,
              text: value,
            }))}
            required
          />
        ),
      },
      {
        id: 'address',
        size: 12,
        field: (
          <FormTextInput
            name="address"
            label="Home Address"
            required
            autoComplete="new-address"
            disabled={formDisabled}
            placeholder={
              isVirtual ? 'Race kit will be delivered to this address' : ''
            }
          />
        ),
      },

      {
        id: 'phoneNumber',
        size: { sm: 12, md: 6 },
        field: (
          <FormTextInput
            name="phoneNumber"
            label="Phone Number"
            required
            autoComplete="new-phoneNumber"
            disabled={formDisabled}
          />
        ),
      },
      {
        id: 'confirmPhoneNumber',
        size: { sm: 12, md: 6 },
        field: (
          <FormTextInput
            name="confirmPhoneNumber"
            label="Confirm Phone Number"
            required
            autoComplete="new-confirmPhoneNumber"
            disabled={formDisabled}
            {...NO_PASTE_PROPS}
          />
        ),
      },
    ],
  },
  {
    id: 'user-emergency-form-details',
    name: 'Emergency Contact Person',
    inputs: [
      ...emergencyContact({ isOnsiteRegistration: false, formDisabled }),
    ],
  },
]
export default IndividualUserFormContent
